// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-1[data-v-351835aa]{display:flex;justify-content:flex-end;margin:0 0 10px}.usertankuang .el-form-item[data-v-351835aa]{display:block}", ""]);
// Exports
module.exports = exports;
